module.exports = __webpack_public_path__ + "static/media/helpIcon.9a0583bf.png";